import { Locale, type GeoSearchResultItem } from '@smg-real-estate/geo-libs';

import { cantonInGeoTags, geoTagToCanton } from './geoCantonMapper';
import { renderHighlightParts, renderPlainTextPart } from './geoSearchResultHelper';
import type { SelectableZipAndCity } from './types';

const findCanton = (parentPath: string[]) => geoTagToCanton(parentPath.find(cantonInGeoTags));

export default function convertToSelectableZipAndCityItems(
  item: GeoSearchResultItem,
  locale: Locale,
): SelectableZipAndCity[] {
  const [zip = '', ...cityNames] = item?.geoLocation?.names[locale] ?? [];

  const zipParts = renderHighlightParts(item.highlights, zip) || renderPlainTextPart(zip);
  const hasCityMatches = cityNames.some((cityName) =>
    renderHighlightParts(item.highlights, cityName),
  );

  return cityNames
    .map((cityName, idx) => {
      let cityParts = renderHighlightParts(item.highlights, cityName);
      const parentPath = item?.geoLocation?.parentPaths?.[idx] ?? [];

      // ignore if zip do not belong to Switzerland (e.g. Lichtenstein)
      if (!parentPath.includes('geo-country-switzerland')) return;

      // ignore current city, if at least one another city matched
      if (!cityParts && hasCityMatches) return;

      // in case only the zip matched, the rendered city name defaults to the plain cityname
      if (!cityParts) cityParts = renderPlainTextPart(cityName);

      const canton = findCanton(parentPath);

      return {
        canton,
        zip,
        city: cityName,
        geoLocation: {
          center: item.geoLocation.center,
        },
        labelParts: [...zipParts, { text: ' ', isHighlighted: false }, ...cityParts],
      };
    })
    .filter((x) => !!x) as SelectableZipAndCity[];
}
